import React from 'react';

type PaymentMethodsProps = {
  /** Tailwind height class for each badge, e.g. "h-6" (default) or "h-8". */
  className?: string;
};

/**
 * Accepted card brand logos (Visa / Mastercard) shown near checkout and in the
 * footer. Rendered as inline SVG on white badges so they stay crisp and never
 * depend on external asset files or network requests.
 */
const VisaLogo: React.FC = () => (
  <svg viewBox="0 0 48 32" role="img" aria-label="Visa" className="h-full w-auto">
    <rect width="48" height="32" rx="4" fill="#ffffff" />
    <rect x="0.5" y="0.5" width="47" height="31" rx="3.5" fill="none" stroke="#e5e7eb" />
    <path
      fill="#1a1f71"
      d="M20.9 11.3l-3.1 9.4h-2.5l3.1-9.4h2.5zm10.6 6.1l1.3-3.6.8 3.6h-2.1zm2.8 3.3h2.3l-2-9.4h-2.1c-.5 0-.9.3-1 .7l-3.7 8.7h2.6l.5-1.4h3.2l.3 1.4zM28 17.6c0-2.5-3.5-2.7-3.5-3.8 0-.3.3-.7 1.1-.8.4 0 1.4-.1 2.6.5l.4-2c-.6-.2-1.5-.5-2.5-.5-2.6 0-4.5 1.4-4.5 3.4 0 1.5 1.3 2.3 2.3 2.8 1 .5 1.4.8 1.4 1.2 0 .7-.8 1-1.5 1-1.3 0-2-.3-2.6-.6l-.5 2.1c.6.3 1.7.5 2.9.5 2.8 0 4.6-1.4 4.6-3.5zm-11.3-6.3L12.6 20.7H10l-2-7.7c-.1-.5-.2-.7-.6-.9-.7-.3-1.7-.7-2.6-.9l.1-.3h4.2c.5 0 1 .4 1.1 1l1.1 5.7 2.7-6.7h2.6z"
    />
  </svg>
);

const MastercardLogo: React.FC = () => (
  <svg viewBox="0 0 48 32" role="img" aria-label="Mastercard" className="h-full w-auto">
    <rect width="48" height="32" rx="4" fill="#ffffff" />
    <rect x="0.5" y="0.5" width="47" height="31" rx="3.5" fill="none" stroke="#e5e7eb" />
    <circle cx="19" cy="16" r="8" fill="#eb001b" />
    <circle cx="29" cy="16" r="8" fill="#f79e1b" />
    <path
      fill="#ff5f00"
      d="M24 10.2a7.98 7.98 0 000 11.6 7.98 7.98 0 000-11.6z"
    />
  </svg>
);

const PaymentMethods: React.FC<PaymentMethodsProps> = ({ className = 'h-6' }) => (
  <div className="flex items-center gap-2">
    <span className={className}>
      <VisaLogo />
    </span>
    <span className={className}>
      <MastercardLogo />
    </span>
  </div>
);

export default PaymentMethods;
